import type { DeviceAssignmentAlertCategory } from '@/lib/api/orpc/contracts/device-assignment-rule';
export const DEVICE_ASSIGNMENT_ALERT_CATEGORY = {
  TO_BE_ASSIGNED: 'TO_BE_ASSIGNED',
  UNKNOWN_ASSIGNMENT: 'UNKNOWN_ASSIGNMENT'
} as const satisfies Record<DeviceAssignmentAlertCategory, DeviceAssignmentAlertCategory>;
export const DEVICE_ASSIGNMENT_ALERT_CATEGORIES = [{
  key: DEVICE_ASSIGNMENT_ALERT_CATEGORY.TO_BE_ASSIGNED,
  i18nKey: 'toBeAssigned',
  to: '/devices/alerts/to-be-assigned'
}, {
  key: DEVICE_ASSIGNMENT_ALERT_CATEGORY.UNKNOWN_ASSIGNMENT,
  i18nKey: 'unknownAssignment',
  to: '/devices/alerts/unknown-assignment'
}] as const;

/** MVP sort 可能列（`person` / `calculatedAt` は sort 不可） */
export const DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS = ['deviceGroup', 'device', 'rule'] as const;
export type DeviceAssignmentAlertSortColumn = (typeof DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS)[number];

/**
 * category 別の sort 可能列（BE `device-assignment-alert-column-definitions` の
 * CATEGORY_FIELD_KEYS + sortable と一致）。
 */
const DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS_BY_CATEGORY = {
  TO_BE_ASSIGNED: ['deviceGroup', 'rule'],
  UNKNOWN_ASSIGNMENT: ['device']
} as const satisfies Record<DeviceAssignmentAlertCategory, readonly DeviceAssignmentAlertSortColumn[]>;
export type DeviceAssignmentAlertCategoryI18nKey = (typeof DEVICE_ASSIGNMENT_ALERT_CATEGORIES)[number]['i18nKey'];
export function isDeviceAssignmentAlertSortColumn(value: string | undefined): value is DeviceAssignmentAlertSortColumn {
  return value !== undefined && (DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS as readonly string[]).includes(value);
}

/** 現在カテゴリで無効な sortColumn は undefined（API 400 防止） */
export function resolveDeviceAssignmentAlertSortColumn(category: DeviceAssignmentAlertCategory, sortColumn: DeviceAssignmentAlertSortColumn | undefined): DeviceAssignmentAlertSortColumn | undefined {
  if (!sortColumn) return undefined;
  const allowed = DEVICE_ASSIGNMENT_ALERT_SORT_COLUMNS_BY_CATEGORY[category];
  return (allowed as readonly string[]).includes(sortColumn) ? sortColumn : undefined;
}